module.exports = __webpack_public_path__ + "img/logo-load.59a6f4dd.svg";